// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 730) return "static/chunks/730-2d3ceaa1b3a2fb6e.js";
	if (chunkId === 438) return "static/chunks/438-3a0e2a150a50692a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"423":"9c435b254beabe2e","573":"72bc0a80764bf132"}[chunkId] + ".js";
};